/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.tool.access.rpc.ToolAccessService
 */

export const requestToolAccessRpc = {
  serviceName: 'com.hubspot.tool.access.rpc.ToolAccessService',
  rpcName: 'requestToolAccess',
  auth: 'app',
  fingerprint: '52hQgmgzK0a18G83i5nXCOP5UDq0a_Cf',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getActiveToolAccessRequestForScopeRpc = {
  serviceName: 'com.hubspot.tool.access.rpc.ToolAccessService',
  rpcName: 'getActiveToolAccessRequestForScope',
  auth: 'app',
  fingerprint: 'BOE_xKbmHOOCHJV7ySKW5OP5UDq0a_Cf',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};